module.exports = __webpack_public_path__ + "img/电子烟专区-蓝.svg";